export default class SampleHardwareRevisionWriteDTO {

    public id: number;
    public pcbVersion: string;
    public description: string;

    constructor(data: { [key: string]: any }) {
        this.id = data['id'];
        this.pcbVersion = data['pcbVersion'];
        this.description = data['description'];
    }
}